import { Action } from '@ngrx/store';
import { IUser } from '../../user-info/IUser';
import {
    IAuthenticateRequest,
    IAuthenticateAccessCode,
    IAuthenticateSecurityQuestion,
    IAuthenticateResponse
} from '../authentication.service';
import { IRememberMe } from '../IRememberMe';

export enum AuthActionTypes {
    Login = '[Auth] Login',
    Logout = '[Auth] Logout',
    LoginSuccess = '[Auth] Login Success',
    LoginFailure = '[Auth] Login Failure',
    LoginRedirect = '[Auth] Login Redirect',
    LoginSelectAccessCode = '[Auth] Select Access Code',
    LoginAccessCodeSent = '[Auth] Access Code Sent',
    LoginAnswerSecurityQuestion = '[Auth] Answer Security Question',
    RememberMe = '[Auth] Remember Me',
    SendUsernamePasswordPin = '[Auth] Send Username Password Pin',
    SendAccessCodeMethod = '[Auth] Send AccessCode Method',
    SendAccessCode = '[Auth] Send AccessCode',
    SendSecurityAnswer = '[Auth] Send Security Answer',
    UpdateBearerToken = '[Auth] Update Bearer Token'
}

export class Login implements Action {
    readonly type = AuthActionTypes.Login;

    constructor(public payload: IAuthenticateResponse) {}
}

export class LoginSelectAccessCode implements Action {
    readonly type = AuthActionTypes.LoginSelectAccessCode;
    constructor(public payload: IAuthenticateResponse) {}
}

export class LoginAnswerSecurityQuestion implements Action {
    readonly type = AuthActionTypes.LoginAnswerSecurityQuestion;
    constructor(public payload: IAuthenticateResponse) {}
}

export class LoginAccessCodeSent implements Action {
    readonly type = AuthActionTypes.LoginAccessCodeSent;
    constructor(public payload: IAuthenticateResponse) {}
}

export class LoginSuccess implements Action {
    readonly type = AuthActionTypes.LoginSuccess;

    constructor(public payload: IAuthenticateResponse) {}
}

export class LoginFailure implements Action {
    readonly type = AuthActionTypes.LoginFailure;

    constructor(public payload: IAuthenticateResponse) {}
}

export class LoginRedirect implements Action {
    readonly type = AuthActionTypes.LoginRedirect;
}

export class Logout implements Action {
    readonly type = AuthActionTypes.Logout;
}

export class SendUsernamePasswordPin implements Action {
    readonly type = AuthActionTypes.SendUsernamePasswordPin;
    constructor(public payload: IAuthenticateRequest) {}
}
export class SendAccessCodeMethod implements Action {
    readonly type = AuthActionTypes.SendAccessCodeMethod;
    constructor(public payload: IAuthenticateAccessCode) {}
}
export class SendAccessCode implements Action {
    readonly type = AuthActionTypes.SendAccessCode;
    constructor(public payload: IAuthenticateAccessCode) {}
}
export class SendSecurityAnswer implements Action {
    readonly type = AuthActionTypes.SendSecurityAnswer;
    constructor(public payload: IAuthenticateSecurityQuestion) {}
}
export class RememberMe implements Action {
    readonly type = AuthActionTypes.RememberMe;
    constructor(public payload: IRememberMe) {}
}
export class UpdateBearerToken implements Action {
    readonly type = AuthActionTypes.UpdateBearerToken;
    constructor(public payload: { token: string }) {}
}
export type AuthActionsUnion =
    | Login
    | LoginSuccess
    | LoginSelectAccessCode
    | LoginAccessCodeSent
    | LoginAnswerSecurityQuestion
    | LoginFailure
    | LoginRedirect
    | Logout
    | RememberMe
    | SendUsernamePasswordPin
    | SendAccessCodeMethod
    | SendAccessCode
    | SendSecurityAnswer
    | UpdateBearerToken;
